import React from "react";

type LeftArrowButtonProps = {
  onClick?: () => void;
  label?: string;
  className?: string;
};

const LeftArrowButton: React.FC<LeftArrowButtonProps> = ({
  onClick,
  label = "Back",
  className
}) => {
  return (
    <div onClick={onClick} className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth="2"
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
      </svg>
      <span>{label}</span>
    </div>
  );
};

export default LeftArrowButton;
